import styled from 'styled-components';

export const ValidityContainer = styled.div`
  font-family: Danske;
  font-size: 0.9em;
`;
